import $ from 'jquery';
import IMask from 'imask';
import 'slick-carousel';
import 'jquery-validation'

window.onload = () => {
  checkBookNavigation();

  $('.SectionCarousel').slick({
    slidesToShow: 1,
    centerPadding: 0,
    draggable: false,
    centerMode: true,
    infinite: true,
    dots: true,
    adaptiveHeight: true
  });

  $('.SectionReviewsWrap').slick({
    slidesToShow: 1,
    centerPadding: 0,
    initialSlide: 1,
    draggable: false,
    variableWidth: true,
    centerMode: true,
    infinite: true,
    mobileFirst: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    if (currentSlide === nextSlide) {
      return;
    }
    $('.SectionReviewsReview .SectionReviewsReviewExpand').each((i, obj) => {
      toggleReview(obj, '0')
    })
  });

  $("#form").validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    submitHandler: function (form, e) {
      e.preventDefault();

      grecaptcha.execute('6LfGqc8UAAAAAFWYf7cUCYGNeuwPuUkzUw-fi_id', { action: 'send_form' })
        .then(function (token) {
          console.log('token', token, arguments)
          document.getElementById('recaptcha').value = token;
          form.submit();
        });

      return false;
    }
  });

  const phoneEl = $('input[name="phone"]');

  IMask(phoneEl[0], {
    mask: '+{7}(000)000-00-00'
  })

};

function toggleReview(el, action) {
  const reviewEl = $(el).closest('.SectionReviewsReview');
  const textEl = $('span', el);

  const isExpanded = action === undefined ? reviewEl.attr('data-expanded') === '1' : action ? '0' : '1';

  let expandedText = $('[data-full="1"]', reviewEl);
  let shortText = $('[data-short="1"]', reviewEl);

  if (isExpanded) {
    shortText.show();
    expandedText.hide();
    reviewEl.attr('data-expanded', '0');
    textEl.text('Развернуть');
  } else {
    shortText.hide();
    expandedText.show();
    reviewEl.attr('data-expanded', '1');
    textEl.text('Свернуть');
  }
}

function toggleMenu() {
  const menu = $('.Menu');

  menu.toggle();
}

function toggleNumberField() {
  const phoneEl = $('[data-name="phone"]');
  const amountEl = $(`input[name="amount"]`);
  const max = +amountEl.attr('max');

  amountEl.attr('max', (!max || max === 100) ? '4' : '100');

  const now = +amountEl.val();
  amountEl.val(Math.min(now, max === 100 ? 100 : 4));

  phoneEl.toggle();

}

function onPhoneInput(el) {
  // const value = $(el).val();
  //
  // $(el).val(new AsYouType('ru').input(value));
}

window.toggleReview = toggleReview;
window.toggleMenu = toggleMenu;
window.toggleNumberField = toggleNumberField;
window.onPhoneInput = onPhoneInput;

window.onscroll = () => {
  checkBookNavigation();
}
window.onresize = () => {
  checkBookNavigation();
}

function checkBookNavigation() {
  if (document.location.pathname.startsWith('/chapter')) {
    const header = $('.Header');
    const footer = $('.Footer');
    const bookNavigation = $('.ChapterPage .BookNavigation');
    const chaptersEl = $('.ChapterPage .BookNavigation .BookNavigationChapters');

    const visibleFooterHeight = Math.max(0, innerHeight - footer[0].getBoundingClientRect().top + footer.height())

    chaptersEl.height(innerHeight - visibleFooterHeight);

    const menuPosition = Math.max(0, header.height() - window.scrollY);

    bookNavigation.css('top', `${menuPosition}px`);
  }
}